import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './Components/ProtectedRoute';
import { TokenProvider } from './Components/TokenContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css'
import Login from './pages/Login/Index';
import Password from './pages/Password';
import Home from './pages/Home/Index';
import Cadastro from './pages/Cadastro/Index';
import Premio from './pages/Premio/Index';
import Premios from './pages/Premios/Index';
import Regulamento from './pages/Regulamento/Index';
import Carrinho from './pages/Carrinho/Index';

import AdminLogin from './pages/Manager/Login';
import AdminHome from './pages/Manager/Home';
import AdminPremios from './pages/Manager/Premios';
import AdminEditVenda from './pages/Manager/EditVenda';
import AdminEditPremio from './pages/Manager/EditPremio';
import AdminParticipantes from './pages/Manager/Participantes';
import AdminEditParticipantes from './pages/Manager/EditParticipante';
import AdminRanking from './pages/Manager/Ranking';
import AuthLayout from './Layouts/AuthLayout';
import ParticipanteLayout from './Layouts/ParticipanteLayout';
import Vendas from './pages/Vendas/Index';
import Tutorial from './pages/Tutorial/Index';
import CronJob from './pages/CronJob';

const App = () => {
    return (
        <TokenProvider>
            <ToastContainer />
            <Router>
                <Routes>
                    <Route path="/vendas/validar" element={<CronJob />} />
                    <Route path="/manager/login" element={<AdminLogin />} />
                    <Route path="/alterar-senha/:token" element={<Password />} />
                    <Route path="/" element={<Home />} />
                    <Route path="/tutorial" element={<Tutorial />} />

                    <Route
                        path="/participantes/cadastro"
                        element={
                            <AuthLayout>
                                <Cadastro />
                            </AuthLayout>
                        }
                    />

                    <Route
                        path="/participantes/login"
                        element={
                            <AuthLayout>
                                <Login />
                            </AuthLayout>
                        }
                    />

                    <Route
                        path="/supervisores/login"
                        element={
                            <AuthLayout>
                                <Login />
                            </AuthLayout>
                        }
                    />

                    <Route
                        path="/premios/meus"
                        element={
                            <ProtectedRoute type="participante" element={
                                <ParticipanteLayout>
                                    <Premio />
                                </ParticipanteLayout>
                            } />
                        }
                    />

                    <Route
                        path="/premios"
                        element={
                            <ProtectedRoute type="participante" element={
                                <ParticipanteLayout>
                                    <Premios />
                                </ParticipanteLayout>
                            } />
                        }
                    />

                    <Route
                        path="/vendas"
                        element={
                            <ProtectedRoute type="participante" element={
                                <ParticipanteLayout>
                                    <Vendas />
                                </ParticipanteLayout>
                            } />
                        }
                    />

                    <Route
                        path="/regulamento"
                        element={
                            <ProtectedRoute type="participante" element={
                                <ParticipanteLayout>
                                    <Regulamento />
                                </ParticipanteLayout>
                            } />
                        }
                    />

                    {/* <Route
                        path="/tutorial"
                        element={
                            <ProtectedRoute type="participante" element={
                                <ParticipanteLayout>
                                    <Tutorial />
                                </ParticipanteLayout>
                            } />
                        }
                    /> */}

                    <Route
                        path="/carrinho"
                        element={
                            <ProtectedRoute type="participante" element={
                                <ParticipanteLayout>
                                    <Carrinho />
                                </ParticipanteLayout>
                            } />
                        }
                    />

                    {/* Manager */}
                    <Route path="/manager/" element={<ProtectedRoute type="administrador" element={<AdminHome />} />} />
                    <Route path="/manager/vendas/editar/:id" element={<ProtectedRoute type="administrador" element={<AdminEditVenda />} />} />
                    <Route path="/manager/premios" element={<ProtectedRoute type="administrador" element={<AdminPremios />} />} />
                    <Route path="/manager/premios/editar/:id" element={<ProtectedRoute type="administrador" element={<AdminEditPremio />} />} />
                    <Route path="/manager/participantes" element={<ProtectedRoute type="administrador" element={<AdminParticipantes />} />} />
                    <Route path="/manager/participantes/editar/:id" element={<ProtectedRoute type="administrador" element={<AdminEditParticipantes />} />} />
                    <Route path="/manager/participantes/ranking/" element={<ProtectedRoute type="administrador" element={<AdminRanking />} />} />
                </Routes>
            </Router>
        </TokenProvider>
    );
};

export default App;